import React from 'react';
import { WelcomeScreen } from '../WelcomeScreen';
import { PermissionsSetup } from '../PermissionsSetup';
import { AddZoneView } from '../AddZoneView';
import { RadiusConfig, PostcodeConfig, PolygonConfig } from '../../types';

interface OnboardingFlowProps {
  step: 'welcome' | 'zone-setup' | 'permissions' | 'complete';
  onWelcomeComplete: () => void;
  onWelcomeSkip: () => void;
  onZoneSetupComplete: (name: string, type: 'radius' | 'postcodes' | 'polygon', config: RadiusConfig | PostcodeConfig | PolygonConfig) => void;
  onPermissionsComplete: () => void;
  onPermissionsSkip: () => void;
  onBackToWelcome: () => void;
}

export const OnboardingFlow: React.FC<OnboardingFlowProps> = ({
  step,
  onWelcomeComplete,
  onWelcomeSkip,
  onZoneSetupComplete,
  onPermissionsComplete,
  onPermissionsSkip,
  onBackToWelcome
}) => {
  switch (step) {
    case 'welcome':
      return <WelcomeScreen onComplete={onWelcomeComplete} onSkip={onWelcomeSkip} />;
    
    case 'zone-setup':
      return (
        <AddZoneView 
          onSave={onZoneSetupComplete}
          onBack={onBackToWelcome}
          isFirstTime={true}
        />
      );
      
    case 'permissions':
      return <PermissionsSetup onComplete={onPermissionsComplete} onSkip={onPermissionsSkip} />;
      
    default:
      return null;
  }
};
